import { Pipe, PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { MarkdownService } from '~/core/services/markdown.service';

/**
 * MarkdownPipe
 * 
 * Converts markdown text to safe HTML in templates
 * 
 * Usage:
 * <div [innerHTML]="botMessage.text | markdown"></div>
 * 
 * This pipe:
 * 1. Takes markdown string as input
 * 2. Calls MarkdownService to convert to HTML
 * 3. Returns SafeHtml that Angular can render safely
 */
@Pipe({
    name: 'markdown',
    standalone: false
})
export class MarkdownPipe implements PipeTransform {
    
    constructor(private markdownService: MarkdownService) {}

    /**
     * Transform markdown to safe HTML
     * 
     * @param markdown Raw markdown string from API
     * @returns SafeHtml object safe for [innerHTML] binding
     * 
     * Example:
     * Input: "# Header\n**bold text**"
     * Output: <h1>Header</h1><p><strong>bold text</strong></p>
     */
    transform(markdown: string | null | undefined): SafeHtml {
        if (!markdown) {
            return '';
        }

        return this.markdownService.toHtml(markdown);
    }
}
